import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconVisa = ({ className }) => (
  <svg className={classNames('footer-icon', className)} width="68" height="22" viewBox="0 0 68 22">
    <g fill="#000" fillRule="nonzero">
      <path d="M29.398 21.598h-5.47L27.349.648h5.47zM49.229 1.16C48.15.735 46.439.266 44.322.266c-5.402 0-9.206 2.853-9.23 6.932-.044 3.009 2.724 4.68 4.795 5.683 2.116 1.026 2.836 1.695 2.836 2.609-.022 1.403-1.71 2.05-3.285 2.05-2.184 0-3.355-.333-5.133-1.114l-.72-.335-.766 4.703c1.283.579 3.647 1.092 6.101 1.115 5.74 0 9.477-2.809 9.521-7.155.022-2.385-1.44-4.212-4.592-5.706-1.913-.958-3.085-1.605-3.085-2.585.023-.892.991-1.805 3.151-1.805 1.779-.045 3.085.378 4.075.802l.495.222.744-4.524zM56.5 14.176c.45-1.204 2.184-5.862 2.184-5.862-.023.045.45-1.226.72-2.006l.382 1.805s1.036 5.015 1.26 6.063H56.5zM63.252.647h-4.231c-1.305 0-2.296.379-2.86 1.739l-8.125 19.211h5.74l1.148-3.142h7.024c.157.735.652 3.142.652 3.142h5.066L63.252.647zM19.359.647L14 14.933l-.585-2.897c-.99-3.343-4.097-6.976-7.563-8.782l4.907 18.321h5.785L25.143.647H19.36z" />
      <path fillOpacity=".8" d="M9.026.647h-8.8l-.09.424C7 2.809 11.547 7 13.415 12.037l-1.913-9.629C11.188 1.07 10.219.691 9.026.648z" />
    </g>
  </svg>
);

IconVisa.propTypes = {
  className: PropTypes.string,
};

IconVisa.defaultProps = {
  className: '',
};
